<template>
    <div>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>商品分类列表</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="formBody">
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="专区搜索" prop="belongId">
                <el-select v-model="formInline.belongId" placeholder="请选择商品专区">
                    <el-option label="算力专区" value="0"></el-option>
                    <el-option label="普通专区" value="1"></el-option>
                    <el-option label="本地专区" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                <el-button size="small" type="primary" icon="el-icon-search" @click="addUser()">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table size="small" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" prop="sortNum" label="序列号" width="100">
                <template slot-scope="scope">
                    <span v-if="!sortStuatsShow">{{ scope.row.sortNum}}</span>
                    <el-input v-else size="small" v-model="scope.row.sortNum" placeholder="输入排序"></el-input>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="typeName" label="类名" width="300">
            </el-table-column>
            <el-table-column align="center" prop="status" label="状态" width="100">
                <template slot-scope="scope">
                    <span>{{ scope.row.status == 1?'已删除':'正常' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="20" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" @click="editUser(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="deleteUser(1, scope.row)">删除</el-button>
                    <el-button size="mini" @click="sortShow()">排序</el-button>
                    <el-button size="mini" type="primary" v-if="sortStuatsShow" @click="sortCLickShow(scope.$index, scope.row)">确定排序</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

        <el-dialog title="新增商品类型" :visible.sync="editTwoFormVisible" width="30%" @click="closeDialog('add')">
            <el-form label-width="80px">
                <el-form-item label="专区" prop="belongId">
                    <el-select v-model="newShowData.belongId" placeholder="请选择专区">
                        <el-option label="算力专区" value="0"></el-option>
                        <el-option label="普通专区" value="1"></el-option>
                        <el-option label="本地专区" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型" prop="typeName">
                    <el-input size="small" v-model="newShowData.typeName" auto-complete="off" placeholder="请输入类型名称"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog('add')">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitFormUnit()">保存</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑商品类型" :visible.sync="editVisible" width="30%" @click="closeDialog('edit')">
            <el-form label-width="80px">
                <el-form-item label="专区" prop="belongId">
                    <el-select v-model="newShowDataEdit.belongId" placeholder="请选择专区">
                        <el-option label="算力专区" value="0"></el-option>
                        <el-option label="普通专区" value="1"></el-option>
                        <el-option label="本地专区" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型" prop="typeName">
                    <el-input size="small" v-model="newShowDataEdit.typeName" auto-complete="off" placeholder="请输入类型名称"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog('edit')">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitEditNit()">保存</el-button>
            </div>
        </el-dialog>
      </div>
    </div>
  </template>
  
  <script>
  import { getGoodsClassList, addGoodsClassList, OrderDelete } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
        return {
            userData: [],
            editTwoFormVisible: false,
            editVisible: false,
            sortStuatsShow: false,
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            newShowData:{
                belongId: '',
                typeName: ''
            },
            newShowDataEdit: {
                typeName: '',
                typeId: '',
                belongId: '',
            },
            formInline: {
                page: 1,
                limit: 10,
                belongId: 0
            }
        }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */
  
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
  
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
        getdata(valList) {
            this.loading = true
            getGoodsClassList(valList).then(res => {
                this.loading = false
                if (res.success == false) {
                    this.$message({
                        type: 'info',
                        message: res.msg
                    })
                } else {
                    this.userData = res.data
                    // 分页赋值
                    this.pageparm.currentPage = this.formInline.page
                    this.pageparm.pageSize = this.formInline.limit
                    this.pageparm.total = res.num
                }
            })
            .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('请稍后再试！')
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
        submitFormUnit() {
            addGoodsClassList({typeName:this.newShowData.typeName,belongId:this.newShowData.belongId})
                .then(res => {
                this.editTwoFormVisible = false
                this.loading = false
                if (res.success) {
                    this.getdata(this.formInline)
                    this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                    })
                } else {
                    this.$message({
                    type: 'info',
                    message: res.msg
                    })
                }
                })
                .catch(err => {
                this.editTwoFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
            })
        },
        sortCLickShow(val, row) {
            addGoodsClassList({typeId:row.id,sort:row.sortNum})
                .then(res => {
                if (res.success) {
                    this.$message({
                        type: 'success',
                        message: row.typeName + '排序成功！'
                    })
                    this.sortStuatsShow = false
                    this.getdata(this.formInline)
                } else {
                    this.$message({
                        type: 'info',
                        message: res.msg
                    })
                }
                })
                .catch(err => {
                    this.loading = false
                    this.$message.error('请稍后再试！')
                })
        },
        search() {
            this.getdata(this.formInline)
        },
        deleteUser(val, row) {
            this.$confirm('确定删除' + row.typeName + '吗?', '信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
            .then(() => {
                addGoodsClassList({typeId:row.id,del:val})
                .then(res => {
                if (res.success) {
                    if(val == 1) {
                    this.$message({
                        type: 'success',
                        message: row.typeName + '删除成功！'
                    })
                    } else{
                    this.$message({
                        type: 'success',
                        message: row.typeName + '删除成功！'
                    })
                    }
                    this.getdata(this.formInline)
                } else {
                    this.$message({
                    type: 'info',
                    message: res.msg
                    })
                }
                })
                .catch(err => {
                this.loading = false
                this.$message.error('请稍后再试！')
                })
            })
            .catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            })
            })
        },
        submitEditNit() {
            console.log(this.newShowDataEdit)
            addGoodsClassList({typeId:this.newShowDataEdit.userId,typeName:this.newShowDataEdit.typeName,belongId:this.newShowDataEdit.belongId})
                .then(res => {
                this.editVisible = false
                this.loading = false
                if (res.success) {
                    this.getdata(this.formInline)
                    this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                    })
                } else {
                    this.$message({
                    type: 'info',
                    message: res.msg
                    })
                }
                })
                .catch(err => {
                this.editVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
            })
        },
        //显示编辑界面
        addUser: function() {
            this.editTwoFormVisible = true;
        },
        editUser(index, row) {
            this.newShowDataEdit.userId = row.id
            this.newShowDataEdit.typeName = row.typeName
            this.editVisible = true
        },
        sortShow() {
            this.sortStuatsShow = true;
        },
        closeDialog(val) {
            if(val == 'add') {
                this.editTwoFormVisible = false
            } else if(val == 'edit'){
                this.editVisible = false
            }
        },
    }
  }
  </script>
  
  <style scoped>
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  </style>
  
   
   
  
   


// WEBPACK FOOTER //
// src/views/pay/GoodsCLass.vue